<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="item in pageMeta.breadcrumb" :to="{ name: item.name }">{{ item.title }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'webGraspManageMultiAccountWebsiteList',params: { web_scrap_id: web_scrap_id } }">查看数据</el-breadcrumb-item>
      <el-breadcrumb-item>查看数据明细</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      查看数据明细
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="card-content">
          <el-table
            :data="tableData"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            ref="multipleTable"
            style="width: 100%">
            <el-table-column
              v-for="item in column"
              :prop="item.prop"
              width="160px"
              :label="item.label">
            </el-table-column>
          </el-table>
          <div class="block" v-if="totalPage>1">
            <el-pagination
              background
              small
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="page_size"
              layout="total, prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {webscrapDataList} from '@/api/index';
import moment from 'moment';

export default {
  beforeCreate() {
    this.pageMeta = this.$route.meta
    this.web_scrap_log_id=this.$route.params.web_scrap_log_id
    this.web_scrap_id=this.$route.params.web_scrap_id
    this.data_type=this.$route.params.data_type
  },
  name: "",
  data: () => ({
    tableData: [],
    loading:false,
    column:[],
    currentPage: 1,
    totalCount: 0,
    totalPage: 0,
    page_size:10
  }),
  created() {
    let para={
      data_type:this.data_type,
      web_scrap_log_id:this.web_scrap_log_id
    }
    webscrapDataList(para).then(res => {
      if (0 === res.status) {
        if(res.data.length){
          let column=[];
          for(let i in res.data[0]){
            if(i!='_id'){
              column.push({
                prop:i,
                label:i,
              })
            }

          }
          this.column=column
        }
        this.data=res.data
        this.totalCount = res.data.length;
        this._getList(1);
      } else {
        this.tableData = [];
        this.totalCount = 0;
        this.currentPage = 1;
        this.totalPage = 0;
      }
    })
  },
  methods: {
    _getList(page) {
      if((typeof page)!="number"){
        return;
      }
      try {

        let data=JSON.parse(JSON.stringify(this.data))
        this.tableData = data.slice((page-1)*this.page_size,(page)*this.page_size);
        this.currentPage = page;
        this.totalPage = Math.ceil(data.length/this.page_size);
      }catch (e) {
        console.log(e);
      }
    },
    handleCurrentChange(currentPage) {
      this._getList(currentPage);
    },
    onSearch() {
      this._getList(1);
    },

  }
}
</script>

<style scoped>
</style>